import { SET_LANGUAGE } from '../utils/type';

export const setLanguage = (selectedLanguage) => ({
  type: SET_LANGUAGE,
  data: selectedLanguage
});
